export default __webpack_public_path__ + "media/images/portfolio/gallery-04-1125x1200_original-826606036f142db88a45f2024e937835.jpg";